module.exports = __webpack_public_path__ + "img/longTextBefore.8130213c.png";